export enum OrderOperations {
    GET_ORDER_BY_ID = 'getOrderById',
}